/** The measured quantity, worked out the same way the server does: nos x length x breadth x depth when any dimension is given
 *  (a dimension left blank is not part of it), otherwise the typed quantity. Returns null while there is nothing to work out. */
export function measuredQuantity({ nos, length, breadth, depth, quantity }) {
  const num = (v) => (v === "" || v == null ? null : Number(v));
  const dims = [length, breadth, depth].map(num).filter((v) => v !== null && !Number.isNaN(v));
  if (dims.length) {
    const n = num(nos) ?? 1;
    const out = dims.reduce((a, b) => a * b, n);
    return Number.isFinite(out) && out > 0 ? Math.round(out * 1000) / 1000 : null;
  }
  const typed = num(quantity);
  return typed !== null && typed > 0 ? Math.round(typed * 1000) / 1000 : null;
}

/** Signed quantity of an entry: a deduction takes quantity away. */
export const signedQuantity = (entry) => (entry.is_deduction ? -1 : 1) * Number(entry.quantity || 0);
